import { Store } from 'vuex';
import { IState } from '@app/store';
import ITicketsState from '@store/modules/data/tickets/types';
import sportOffer, { ISportOfferState, SportOfferGetters } from './sportOffer';
import getLottoModule, { ILottoOfferState, SET_LOTTO_EVENTS } from './lottoOffer/lottoIndex';
import {
    default as authentication,
    IAuthenticationState,
    AuthenticationGetters,
} from './authentication/authenticationIndex';
import {
    loadLiveEvents,
} from './tickets/subscriptions';
import country, { ICountryState } from './country/countryIndex';
import flags from '@src/terminal/store/flags'
import specialOffer, { ISpecialsState } from './specialOffer/specialsIndex';
import news, { INewsState } from './news/newsIndex';
import tickets from './tickets/index';
import games, { IGamesState } from './games/gameIndex';
import results, { IResultsState } from './results/resultsIndex';
import banners, { IBannersState } from './banners/bannerIndex';
import competitions from '@src/app/competitions/store';
import { CompetitionsState } from '@src/app/competitions/store/types';

export interface IDataState {
    sportOffer: ISportOfferState;
    lottoOffer: ILottoOfferState;
    authentication: IAuthenticationState;
    tickets: ITicketsState;
    specialOffer: ISpecialsState;
    country: ICountryState;
    games: IGamesState;
    news: INewsState;
    results: IResultsState;
    banners: IBannersState;
    competitions: CompetitionsState;
}

export interface DataGetters {
    sportOffer: SportOfferGetters;
    authentication: AuthenticationGetters;
}

export const publicActions: Record<string, string> = {
    SET_LOTTO_EVENTS: `lottoOffer/${SET_LOTTO_EVENTS}`,
};

export function subscriptions(store: Store<IState>, options: {
    moduleNamespace: string[],
}) {
    // temporary disable until the bug is found
    // notifyOtherTabs(store, options.moduleNamespace);
    loadLiveEvents(store);
}

export default {
    namespaced: true,

    modules: {
        country,
        flags,
        sportOffer,
        authentication,
        tickets,
        specialOffer,
        games,
        results,
        news,
        banners,
        lottoOffer: getLottoModule(),
        competitions,
    },
};

export const moduleNamespaces = {
    authentication: ['authentication'],
} as Record<string, string[]>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/dataIndex.ts